module.exports = __webpack_public_path__ + "static/dallas-a205af61bc116c42f7e0b4295bfbf0c7.png";